import { BuildType } from './ApiService';
import { EducationInstitutionModel, EducationInstitutionsResponse, QueryEducationInstitutionParams } from '@/types/EducationInstitution';

export const educationInstitutionApiEndpoints = (build: BuildType) => ({
    educationInstitutions: build.query<EducationInstitutionsResponse, QueryEducationInstitutionParams>({
        query: params => ({
            url: 'education-institutions/query',
            method: 'POST',
            body: params,
        }),
        providesTags: ['EducationInstitutions'],
        transformResponse: (response: EducationInstitutionsResponse) => response,
    }),
    educationInstitutionDetails: build.query<EducationInstitutionModel, string>({
        query: id => `education-institutions/${id}`,
        transformResponse: (response: EducationInstitutionModel) => response,
    }),
    favoriteEducationInstitution: build.mutation<void, string>({
        query: institutionId => ({
            url: `user-education-institutions/${institutionId}/favorite`,
            method: 'POST',
        }),
        invalidatesTags: ['Favorites', 'EducationInstitutions'],
    }),
});
